<template>
  <div class="bhf__banner">
    <div class="bhf__banner-logo">
      <a href="https://www.bhf.org.uk" target="_blank" class="bhf__banner-link">
        <img src="@/assets/imgs/bhf_logo.svg" alt="BHF Logo" />
      </a>

      <router-link to="/" class="bhf__banner-link bhf__banner-link--stretch">
        <div class="text__content--18 text--bold">How to say no to food</div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar"
};
</script>

<style lang="scss" scoped>
.bhf__banner {
  background: $bhf-gradient;
  color: $white;
  text-align: left;
  height: 56px;
  width: 100%;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;

  &-logo {
    display: flex;
    height: 100%;

    @include media-breakpoint("md") {
      margin-left: 0.5rem;
    }

    img {
      margin: 0.5rem;
    }
  }

  &-link {
    height: 100%;
    color: white;
    text-decoration: none;
    display: flex;
    align-items: center;
    padding: 0.75rem 0;
    flex: 0 0 auto;

    &--stretch {
      flex: 1 1 auto;
    }
  }
}
</style>
